import { CommonStatsState } from 'types/user';

export const getIsPending = (entity: CommonStatsState) => entity?.isPending && !entity.data;
